import Qs from "qs";
const ApiRoutes = {
  AuthenticationController: {
    create: () => ({ url: "/system/authentication/services/backends" }),
    delete: (backendId) => ({ url: `/system/authentication/services/backends/${backendId}` }),
    disableUser: (userId) => ({ url: `/system/authentication/users/${userId}/disable` }),
    enableUser: (userId) => ({ url: `/system/authentication/users/${userId}/enable` }),
    load: (serviceId) => ({ url: `/system/authentication/services/backends/${serviceId}` }),
    loadActive: () => ({ url: "/system/authentication/services/active-backend" }),
    loadUsersPaginated: (authBackendId) => ({
      url: `/system/authentication/services/backends/${authBackendId}/users`
    }),
    loadActiveBackendType: () => ({ url: "/system/authentication/services/backends/active-backend/type" }),
    servicesPaginated: () => ({ url: "/system/authentication/services/backends" }),
    testConnection: () => ({ url: "/system/authentication/services/test/backend/connection" }),
    testLogin: () => ({ url: "/system/authentication/services/test/backend/login" }),
    update: (serviceId) => ({ url: `/system/authentication/services/backends/${serviceId}` }),
    updateConfiguration: () => ({ url: "/system/authentication/services/configuration" })
  },
  AuthzRolesController: {
    load: (roleId) => ({ url: `/authz/roles/${roleId}` }),
    delete: (roleId) => ({ url: `/authz/roles/${roleId}` }),
    list: () => ({ url: "/authz/roles" }),
    removeMember: (roleId, username) => ({ url: `/authz/roles/${roleId}/assignee/${username}` }),
    addMembers: (roleId) => ({ url: `/authz/roles/${roleId}/assignees` }),
    loadRolesForUser: (username) => ({ url: `/authz/roles/user/${username}` }),
    loadUsersForRole: (roleId) => ({ url: `/authz/roles/${roleId}/assignees` })
  },
  CatalogsController: {
    showEntityIndex: () => ({ url: "/system/catalog" }),
    queryEntities: () => ({ url: "/system/catalog" })
  },
  CodecTypesController: {
    list: () => ({ url: "/system/codecs/types/all" })
  },
  ContentPacksController: {
    list: () => ({ url: "/system/content_packs/latest" }),
    get: (contentPackId) => ({ url: `/system/content_packs/${contentPackId}` }),
    getRev: (contentPackId, revision) => ({
      url: `/system/content_packs/${contentPackId}/${revision}`
    }),
    downloadRev: (contentPackId, revision) => ({
      url: `/system/content_packs/${contentPackId}/${revision}/download`
    }),
    create: () => ({ url: "/system/content_packs" }),
    delete: (contentPackId) => ({ url: `/system/content_packs/${contentPackId}` }),
    deleteRev: (contentPackId, revision) => ({
      url: `/system/content_packs/${contentPackId}/${revision}`
    }),
    install: (contentPackId, revision) => ({
      url: `/system/content_packs/${contentPackId}/${revision}/installations`
    }),
    installList: (contentPackId) => ({ url: `/system/content_packs/${contentPackId}/installations` }),
    uninstall: (contentPackId, installId) => ({
      url: `/system/content_packs/${contentPackId}/installations/${installId}`
    }),
    uninstallDetails: (contentPackId, installId) => ({
      url: `/system/content_packs/${contentPackId}/installations/${installId}/uninstall_details`
    })
  },
  ClusterApiResource: {
    list: () => ({ url: "/system/cluster/nodes" }),
    node: () => ({ url: "/system/cluster/node" }),
    elasticsearchStats: () => ({ url: "/system/cluster/stats/elasticsearch" })
  },
  ClusterConfigResource: {
    config: () => ({ url: "/system/cluster_config" })
  },
  GrokPatternsController: {
    test: () => ({ url: "/system/grok/test" }),
    paginated: () => ({ url: "/system/grok/paginated" })
  },
  DashboardsApiController: {
    create: () => ({ url: "/dashboards" }),
    index: () => ({ url: "/dashboards" }),
    get: (id) => ({ url: `/dashboards/${id}` }),
    delete: (id) => ({ url: `/dashboards/${id}` }),
    update: (id) => ({ url: `/dashboards/${id}` }),
    addWidget: (id) => ({ url: `/dashboards/${id}/widgets` }),
    removeWidget: (dashboardId, widgetId) => ({
      url: `/dashboards/${dashboardId}/widgets/${widgetId}`
    }),
    widget: (dashboardId, widgetId) => ({ url: `/dashboards/${dashboardId}/widgets/${widgetId}` }),
    updateWidget: (dashboardId, widgetId) => ({
      url: `/dashboards/${dashboardId}/widgets/${widgetId}`
    }),
    widgetValue: (dashboardId, widgetId) => ({
      url: `/dashboards/${dashboardId}/widgets/${widgetId}/value`
    }),
    updatePositions: (dashboardId) => ({ url: `/dashboards/${dashboardId}/positions` })
  },
  DecoratorsResource: {
    available: () => ({ url: "/search/decorators/available" }),
    create: () => ({ url: "/search/decorators" }),
    get: () => ({ url: "/search/decorators" }),
    remove: (decoratorId) => ({ url: `/search/decorators/${decoratorId}` }),
    update: (decoratorId) => ({ url: `/search/decorators/${decoratorId}` })
  },
  DeflectorApiController: {
    cycle: (indexSetId) => ({ url: `/cluster/deflector/${indexSetId}/cycle` }),
    list: (indexSetId) => ({ url: `/system/deflector/${indexSetId}` })
  },
  EntityScopeController: {
    getScope: () => ({ url: "/entity_scopes" })
  },
  EntityShareController: {
    prepare: (entityGRN) => ({ url: `/authz/shares/entities/${entityGRN}/prepare` }),
    prepareEntityCreate: () => ({ url: `/authz/shares/entities/prepare` }),
    update: (entityGRN) => ({ url: `/authz/shares/entities/${entityGRN}` }),
    userSharesPaginated: (username) => ({ url: `/authz/shares/user/${username}` }),
    entityScopes: () => ({ url: "/entity_scopes" })
  },
  EventDefinitionsApiController: {
    list: () => ({ url: "/events/definitions" }),
    paginated: () => ({ url: "/events/definitions/paginated" }),
    get: (definitionId) => ({ url: `/events/definitions/${definitionId}` }),
    create: () => ({ url: "/events/definitions" }),
    bulkDelete: () => ({ url: "/events/definitions/bulk_delete" }),
    bulkSchedule: () => ({ url: "/events/definitions/bulk_schedule" }),
    bulkUnschedule: () => ({ url: "/events/definitions/bulk_unschedule" }),
    update: (definitionId) => ({ url: `/events/definitions/${definitionId}` }),
    delete: (definitionId) => ({ url: `/events/definitions/${definitionId}` })
  },
  EventNotificationsApiController: {
    list: () => ({ url: "/events/notifications" }),
    paginated: () => ({ url: "/events/notifications/paginated" }),
    get: (definitionId) => ({ url: `/events/notifications/${definitionId}` }),
    create: () => ({ url: "/events/notifications" }),
    bulkDelete: () => ({ url: "/events/notifications/bulk_delete" }),
    bulkSchedule: () => ({ url: "/events/notifications/bulk_schedule" }),
    bulkUnschedule: () => ({ url: "/events/notifications/bulk_unschedule" }),
    update: (definitionId) => ({ url: `/events/notifications/${definitionId}` }),
    delete: (definitionId) => ({ url: `/events/notifications/${definitionId}` })
  },
  HTTPHeaderAuthConfigController: {
    load: () => ({ url: "/system/authentication/http-header-auth-config" }),
    update: () => ({ url: "/system/authentication/http-header-auth-config" })
  },
  IndexerClusterApiController: {
    health: () => ({ url: "/system/indexer/cluster/health" }),
    name: () => ({ url: "/system/indexer/cluster/name" }),
    info: () => ({ url: "/system/indexer/cluster/info" })
  },
  IndexerFailuresApiController: {
    count: (since) => ({ url: `/system/indexer/failures/count?since=${since}` }),
    list: (limit, offset) => ({ url: `/system/indexer/failures?limit=${limit}&offset=${offset}` })
  },
  IndexerOverviewApiResource: {
    list: (indexSetId) => ({ url: `/system/indexer/overview/${indexSetId}` })
  },
  IndexRangesApiController: {
    list: () => ({ url: "/system/indices/ranges" }),
    rebuild: (indexSetId) => ({ url: `/system/indices/ranges/index_set/${indexSetId}/rebuild` }),
    rebuildSingle: (index) => ({ url: `/system/indices/ranges/${index}/rebuild` })
  },
  IndexSetsApiController: {
    list: (stats, only_open = false) => ({
      url: `/system/indices/index_sets?stats=${stats}&only_open=${only_open}`
    }),
    listPaginated: (skip, limit, stats) => ({
      url: `/system/indices/index_sets?skip=${skip}&limit=${limit}&stats=${stats}`
    }),
    get: (indexSetId) => ({ url: `/system/indices/index_sets/${indexSetId}` }),
    getIndexSetStats: (indexSetId) => ({ url: `/system/indices/index_sets/${indexSetId}/stats` }),
    create: () => ({ url: "/system/indices/index_sets" }),
    delete: (indexSetId, deleteIndices) => ({
      url: `/system/indices/index_sets/${indexSetId}?delete_indices=${deleteIndices}`
    }),
    searchPaginated: (searchTerm, skip, limit, stats) => ({
      url: `/system/indices/index_sets/search?searchTitle=${searchTerm}&skip=${skip}&limit=${limit}&stats=${stats}`
    }),
    setDefault: (indexSetId) => ({ url: `/system/indices/index_sets/${indexSetId}/default` }),
    stats: () => ({ url: "/system/indices/index_sets/stats" })
  },
  IndicesApiController: {
    close: (indexName) => ({ url: `/system/indexer/indices/${indexName}/close` }),
    delete: (indexName) => ({ url: `/system/indexer/indices/${indexName}` }),
    list: (indexSetId) => ({ url: `/system/indexer/indices/${indexSetId}/list` }),
    listAll: () => ({ url: "/system/indexer/indices" }),
    listClosed: (indexSetId) => ({ url: `/system/indexer/indices/${indexSetId}/closed` }),
    multiple: () => ({ url: "/system/indexer/indices/multiple" }),
    reopen: (indexName) => ({ url: `/system/indexer/indices/${indexName}/reopen` })
  },
  InputsApiController: {
    list: () => ({ url: "/system/inputs" }),
    get: (id) => ({ url: `/system/inputs/${id}` }),
    globalRecentMessage: (inputId) => ({ url: `/${inputId}` }),
    references: (inputId) => ({ url: `/system/inputs/references/${inputId}` })
  },
  InputStatesController: {
    summary: () => ({ url: "/system/inputstates/summary" }),
    start: (inputId) => ({ url: `/system/inputstates/${inputId}` }),
    stop: (inputId) => ({ url: `/system/inputstates/${inputId}` })
  },
  ClusterInputStatesController: {
    list: () => ({ url: "/cluster/inputstates" }),
    start: (inputId) => ({ url: `/cluster/inputstates/${inputId}` }),
    stop: (inputId) => ({ url: `/cluster/inputstates/${inputId}` }),
    setup: (inputId) => ({ url: `/cluster/inputstates/setup/${inputId}` })
  },
  ClusterLoggersResource: {
    loggers: () => ({ url: "/cluster/system/loggers" }),
    subsystems: () => ({ url: "/cluster/system/loggers/subsystems" }),
    setSubsystemLoggerLevel: (nodeId, subsystem, loglevel) => ({
      url: `/cluster/system/loggers/${nodeId}/subsystems/${subsystem}/level/${loglevel}`
    })
  },
  ClusterSupportBundleController: {
    delete: (filename) => ({ url: `/cluster/debug/support/bundle/${filename}` }),
    download: (filename) => ({ url: `/cluster/debug/support/bundle/download/${filename}` }),
    list: () => ({ url: "/cluster/debug/support/bundle/list" }),
    create: () => ({ url: "/cluster/debug/support/bundle/build" })
  },
  MessageFieldsApiController: {
    list: () => ({ url: "/system/fields" }),
    types: () => ({ url: "views/fields" })
  },
  MetricsApiController: {
    multiple: () => ({ url: "/system/metrics/multiple" }),
    byNamespace: (namespace) => ({ url: `/system/metrics/namespace/${namespace}` })
  },
  ClusterMetricsApiController: {
    multiple: (nodeId) => ({ url: `/cluster/${nodeId}/metrics/multiple` }),
    multipleAllNodes: () => ({ url: "/cluster/metrics/multiple" }),
    byNamespace: (nodeId, namespace) => ({ url: `/cluster/${nodeId}/metrics/namespace/${namespace}` })
  },
  OutputsApiController: {
    index: () => ({ url: "/system/outputs" }),
    create: () => ({ url: "/system/outputs" }),
    delete: (outputId) => ({ url: `/system/outputs/${outputId}` }),
    update: (outputId) => ({ url: `/system/outputs/${outputId}` }),
    availableType: (type) => ({ url: `/system/outputs/available/${type}` }),
    availableTypes: () => ({ url: "/system/outputs/available" })
  },
  SavedSearchesApiController: {
    create: () => ({ url: "/search/saved" }),
    delete: (savedSearchId) => ({ url: `/search/saved/${savedSearchId}` }),
    update: (savedSearchId) => ({ url: `/search/saved/${savedSearchId}` })
  },
  SessionsApiController: {
    validate: () => ({ url: "/system/sessions" })
  },
  StreamsApiController: {
    index: () => ({ url: "/streams" }),
    paginated: () => ({ url: "/streams/paginated" }),
    withoutSecurityDefaults: () => ({ url: "/streams/no_security" }),
    get: (streamId) => ({ url: `/streams/${streamId}` }),
    bulk_delete: () => ({ url: "/streams/bulk_delete" }),
    bulk_resume: () => ({ url: "/streams/bulk_resume" }),
    bulk_pause: () => ({ url: "/streams/bulk_pause" }),
    create: () => ({ url: "/streams" }),
    update: (streamId) => ({ url: `/streams/${streamId}` }),
    cloneStream: (streamId) => ({ url: `/streams/${streamId}/clone` }),
    delete: (streamId) => ({ url: `/streams/${streamId}` }),
    pause: (streamId) => ({ url: `/streams/${streamId}/pause` }),
    resume: (streamId) => ({ url: `/streams/${streamId}/resume` }),
    testMatch: (streamId) => ({ url: `/streams/${streamId}/testMatch` }),
    byIndexSet: (indexSetId) => ({ url: `/streams/byIndex/${indexSetId}` })
  },
  StreamOutputsApiController: {
    add: (streamId) => ({ url: `/streams/${streamId}/outputs` }),
    index: (streamId) => ({ url: `/streams/${streamId}/outputs` }),
    delete: (streamId, outputId) => ({ url: `/streams/${streamId}/outputs/${outputId}` })
  },
  StreamRulesApiController: {
    delete: (streamId, streamRuleId) => ({ url: `/streams/${streamId}/rules/${streamRuleId}` }),
    update: (streamId, streamRuleId) => ({ url: `/streams/${streamId}/rules/${streamRuleId}` }),
    create: (streamId) => ({ url: `/streams/${streamId}/rules` })
  },
  StreamOutputFilterRuleApiController: {
    get: (streamId) => ({ url: `/streams/${streamId}/destinations/filters` }),
    countByStreams: () => ({ url: "/streams/destinations/filters/count" }),
    delete: (streamId, filterId) => ({ url: `/streams/${streamId}/destinations/filters/${filterId}` }),
    update: (streamId, filterId) => ({ url: `/streams/${streamId}/destinations/filters/${filterId}` }),
    create: (streamId) => ({ url: `/streams/${streamId}/destinations/filters` })
  },
  SystemApiController: {
    info: () => ({ url: "/system" }),
    jvm: () => ({ url: "/system/jvm" }),
    fields: () => ({ url: "/system/fields" }),
    locales: () => ({ url: "/system/locales" })
  },
  SystemJobsApiController: {
    list: () => ({ url: "/cluster/jobs" }),
    getJob: (jobId) => ({ url: `/cluster/jobs/${jobId}` }),
    acknowledgeJob: (jobId) => ({ url: `/system/jobs/acknowledge/${jobId}` }),
    cancelJob: (jobId) => ({ url: `/cluster/jobs/${jobId}` })
  },
  SystemMessagesApiController: {
    all: (page) => ({ url: `/system/messages?page=${page}` })
  },
  SystemSearchVersionApiController: {
    satisfiesVersion: (distribution, version) => ({
      url: `/system/searchVersion/satisfiesVersion/${distribution}${version ? `?version=${version}` : ""}`
    })
  },
  ToolsApiController: {
    grokTest: () => ({ url: "/tools/grok_tester" }),
    jsonTest: () => ({ url: "/tools/json_tester" }),
    naturalDateTest: (string, timezone) => ({
      url: `/tools/natural_date_tester?string=${string}&timezone=${timezone}`
    }),
    regexTest: () => ({ url: "/tools/regex_tester" }),
    regexValidate: (regex) => ({ url: `/tools/regex_tester/validate?regex=${regex}` }),
    regexReplaceTest: () => ({ url: "/tools/regex_replace_tester" }),
    splitAndIndexTest: () => ({ url: "/tools/split_and_index_tester" }),
    substringTest: () => ({ url: "/tools/substring_tester" }),
    containsStringTest: () => ({ url: "/tools/contains_string_tester" }),
    lookupTableTest: () => ({ url: "/tools/lookup_table_tester" }),
    urlAllowlistCheck: () => ({ url: "/system/urlallowlist/check" }),
    urlAllowlistGenerateRegex: () => ({ url: "/system/urlallowlist/generate_regex" })
  },
  TelemetryApiController: {
    info: () => ({ url: "/telemetry" }),
    setting: () => ({ url: "/telemetry/user/settings" })
  },
  UniversalSearchApiController: {
    _streamFilter(streamId) {
      return streamId ? { filter: `streams:${streamId}` } : {};
    },
    _buildBaseQueryString(query, timerange, streamId) {
      const streamFilter = this._streamFilter(streamId);
      const queryString = {
        query,
        ...timerange,
        ...streamFilter
      };
      return queryString;
    },
    _buildUrl(url, queryString) {
      return `${url}?${Qs.stringify(queryString)}`;
    },
    search(type, query, timerange, streamId, limit, offset, sortField, sortOrder, decorate) {
      const url = `/search/universal/${type}`;
      const queryString = this._buildBaseQueryString(query, timerange, streamId);
      if (limit) {
        queryString.limit = limit;
      }
      if (offset) {
        queryString.offset = offset;
      }
      if (sortField && sortOrder) {
        queryString.sort = `${sortField}:${sortOrder}`;
      }
      if (decorate !== void 0) {
        queryString.decorate = decorate;
      }
      return { url: this._buildUrl(url, queryString) };
    },
    export(type, query, timerange, streamId, limit, offset, fields) {
      const url = `/search/universal/${type}/export`;
      const queryString = this._buildBaseQueryString(query, timerange, streamId);
      if (limit) {
        queryString.limit = limit;
      }
      if (offset) {
        queryString.offset = offset;
      }
      if (fields) {
        queryString.fields = fields.join(",");
      }
      return { url: this._buildUrl(url, queryString) };
    }
  },
  UsersApiController: {
    changePassword: (userId) => ({ url: `/users/${userId}/password` }),
    create: () => ({ url: "/users" }),
    list: () => ({ url: "/users" }),
    paginated: () => ({ url: "/users/paginated" }),
    load: (userId) => ({ url: `/users/id/${userId}` }),
    loadByUsername: (username) => ({ url: `/users/${username}` }),
    delete: (id) => ({ url: `/users/id/${id}` }),
    update: (userId) => ({ url: `/users/${userId}` }),
    create_token: (userId, tokenName) => ({ url: `/users/${userId}/tokens/${tokenName}` }),
    delete_token: (userId, tokenName) => ({ url: `/users/${userId}/tokens/${tokenName}` }),
    list_tokens: (userId) => ({ url: `/users/${userId}/tokens` }),
    setStatus: (userId, accountStatus) => ({ url: `/users/${userId}/status/${accountStatus}` })
  },
  TokenManagementController: {
    paginated: () => ({ url: "/token_usage/paginated" })
  },
  DashboardsController: {
    show: (id) => ({ url: `/dashboards/${id}` })
  },
  ExtractorsController: {
    create: (inputId) => ({ url: `/system/inputs/${inputId}/extractors` }),
    delete: (inputId, extractorId) => ({ url: `/system/inputs/${inputId}/extractors/${extractorId}` }),
    order: (inputId) => ({ url: `/system/inputs/${inputId}/extractors/order` }),
    update: (inputId, extractorId) => ({ url: `/system/inputs/${inputId}/extractors/${extractorId}` })
  },
  MessagesController: {
    analyze: (index, string) => ({ url: `/messages/${index}/analyze?string=${string}` }),
    parse: () => ({ url: "/messages/parse" }),
    single: (index, messageId) => ({ url: `/messages/${index}/${messageId}` }),
    exportSearch: (searchId) => ({ url: `/views/search/messages/${searchId}` }),
    exportSearchType: (searchId, searchTypeId) => ({
      url: `/views/search/messages/${searchId}/${searchTypeId}`
    }),
    jobResults: (exportJobId, filename) => ({
      url: `/views/search/messages/job/${exportJobId}/${filename}`
    })
  },
  ExportJobsController: {
    exportSearch: (searchId) => ({ url: `/views/export/${searchId}` }),
    exportSearchType: (searchId, searchTypeId) => ({
      url: `/views/export/${searchId}/${searchTypeId}`
    })
  },
  MapDataController: {
    search: () => ({ url: "/search/mapdata" })
  },
  PipelinesController: {
    list: () => ({ url: "/system/pipelines/pipeline" }),
    paginatedList: () => ({ url: "/system/pipelines/pipeline/paginated" }),
    create: () => ({ url: "/system/pipelines/pipeline" }),
    get: (pipelineId) => ({ url: `/system/pipelines/pipeline/${pipelineId}` }),
    update: (pipelineId) => ({ url: `/system/pipelines/pipeline/${pipelineId}` }),
    delete: (pipelineId) => ({ url: `/system/pipelines/pipeline/${pipelineId}` }),
    parse: () => ({ url: "/system/pipelines/pipeline/parse" }),
    updateRouting: () => ({ url: "/system/pipelines/pipeline/routing" })
  },
  RulesController: {
    list: () => ({ url: "/system/pipelines/rule" }),
    paginatedList: () => ({ url: "/system/pipelines/rule/paginated" }),
    create: () => ({ url: "/system/pipelines/rule" }),
    get: (ruleId) => ({ url: `/system/pipelines/rule/${ruleId}` }),
    update: (ruleId) => ({ url: `/system/pipelines/rule/${ruleId}` }),
    delete: (ruleId) => ({ url: `/system/pipelines/rule/${ruleId}` }),
    multiple: () => ({ url: "/system/pipelines/rule/multiple" }),
    functions: () => ({ url: "/system/pipelines/rule/functions" }),
    parse: () => ({ url: "/system/pipelines/rule/parse" }),
    simulate: () => ({ url: "/system/pipelines/rule/simulate" }),
    metricsConfig: () => ({ url: "/system/pipelines/rule/config/metrics" })
  },
  RuleBuilderController: {
    create: () => ({ url: "/system/pipelines/rulebuilder" }),
    update: (ruleId) => ({ url: `/system/pipelines/rulebuilder/${ruleId}` }),
    validate: () => ({ url: "/system/pipelines/rulebuilder/validate" }),
    simulate: () => ({ url: "/system/pipelines/rulebuilder/simulate" }),
    listConditionsDict: () => ({ url: "/system/pipelines/rulebuilder/conditions" }),
    listActionsDict: () => ({ url: "/system/pipelines/rulebuilder/actions" })
  },
  ConnectionsController: {
    list: () => ({ url: "/system/pipelines/connections" }),
    to_stream: () => ({ url: "/system/pipelines/connections/to_stream" }),
    to_pipeline: () => ({ url: "/system/pipelines/connections/to_pipeline" })
  },
  SimulatorController: {
    simulate: () => ({ url: "/system/pipelines/simulate" })
  },
  ping: () => ({ url: "/" })
};
export default ApiRoutes;
